import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/adduser.svg'
import _imports_1 from '@/assets/icons/delete.svg'
import _imports_2 from '@/assets/icons/deletedisabled.svg'
import _imports_3 from '@/assets/icons/active.svg'
import _imports_4 from '@/assets/icons/inactive.svg'
import _imports_5 from '@/assets/icons/pending.svg'


const _hoisted_1 = { class: "usrprdtext btm-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold-24" }, "Company Administrators", -1)
const _hoisted_3 = { class: "utils" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"40px"},
  title: "Add company admin",
  alt: "Click to add company admin"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  src: _imports_1,
  style: {"width":"40px"},
  title: "Delete company admin",
  alt: "Click to delete company admin"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_2,
  style: {"width":"40px"},
  title: "Delete company admin disabled",
  alt: "Click to delete company admin disabled"
}
const _hoisted_7 = { class: "text-div" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Are you sure you want to remove company admin?", -1)
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = {
  key: 0,
  src: _imports_3,
  style: {"width":"25px"},
  alt: "activeimg",
  title: "activeimg"
}
const _hoisted_12 = {
  key: 1,
  src: _imports_4,
  style: {"width":"25px"},
  alt: "inactiveimg",
  title: "inactiveimg"
}
const _hoisted_13 = {
  key: 2,
  src: _imports_5,
  style: {"width":"25px"},
  alt: "pendingimg",
  title: "pendingimg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_AddCompanyAdminModal = _resolveComponent("AddCompanyAdminModal")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          plain: "",
          class: "delbtn",
          onClick: _ctx.addCompanyAdmin,
          id: "addadminbutton"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          plain: "",
          class: "delbtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteConfim = true)),
          id: "deleteadmin",
          disabled: _ctx.selectedUserIds.length === 0
        }, {
          default: _withCtx(() => [
            (_ctx.selectedUserIds.length !== 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.selectedUserIds.length === 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_dialog, {
          title: "Delete Users",
          modelValue: _ctx.showDeleteConfim,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteConfim) = $event)),
          width: "35%",
          top: "25vh",
          center: ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_el_button, {
                id: "deleteadmincancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteConfim = false)),
                round: "",
                class: "cancelbtn",
                variant: "outline-dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                id: "deleteadmincancel",
                type: "danger",
                onClick: _ctx.removeCompanyAdmin,
                round: "",
                class: "deletebutton"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Confirm")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.selectedUserIds.length), 1),
                _createTextVNode(" admin selected ")
              ]),
              _hoisted_8,
              _hoisted_9
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      id: "licenseadmintable",
      data: _ctx.licAdminsList,
      style: {"width":"100%"},
      "max-height": "400",
      "scrollbar-always-on": "",
      onSelect: _ctx.handleSelectionChange,
      onSelectAll: _ctx.handleSelectionChange,
      "row-style": _ctx.rowdatastyle,
      "show-header": false,
      "empty-text": "No license administrators"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, { prop: "name" }, {
          default: _withCtx((name) => [
            _createElementVNode("div", null, _toDisplayString(name.row.firstName) + "    " + _toDisplayString(name.row.lastName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { prop: "email" }),
        _createVNode(_component_el_table_column, { prop: "status" }, {
          default: _withCtx((comp) => [
            (comp.row.status === 'Active')
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            (comp.row.status === 'inactive')
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true),
            (comp.row.status === 'pending')
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : _createCommentVNode("", true),
            _createTextVNode("   " + _toDisplayString(comp.row.status), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSelect", "onSelectAll", "row-style"])), [
      [_directive_loading, _ctx.adminLoading]
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAddCompanyAdmin,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAddCompanyAdmin) = $event)),
      direction: "rtl",
      "destroy-on-close": "",
      size: "40%",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCompanyAdminModal)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}